import { createDomain } from 'effector';

export const rootDomain = createDomain('rootDomain');

export const tokenDomain = rootDomain.createDomain('tokenDomain');

export const camerasDomain = rootDomain.createDomain('camerasDomain');

export const recordingsDomain = rootDomain.createDomain('recordingsDomain');

export const videoChatDomain = rootDomain.createDomain('videoChatDomain');

export const authDomain = rootDomain.createDomain('authDomain');

export const systemDomain = rootDomain.createDomain('systemDomain');

export const devicesDomain = rootDomain.createDomain('devicesDomain');

export const transactionsDomain = rootDomain.createDomain('transactionsDomain');

export const modalsViewDomain = rootDomain.createDomain('modalsViewDomain');

export const sitesDomain = rootDomain.createDomain('sitesDomain');

export const videoWallDomain = rootDomain.createDomain('videoWallDomain');

export const videoConnectionDomain = rootDomain.createDomain('videoConnectionDomain');

export const viewDomain = rootDomain.createDomain('viewDomain');

export const archiveDomain = rootDomain.createDomain('archiveDomain');

export const settingsDomain = rootDomain.createDomain('settingsDomain');